<!--div class="btn-group btn-group-toggle  p-1 mb-1" ngbRadioGroup name="radioCode">
  <label ngbButtonLabel class="btn btn-outline-light btn-sm  border-0 ">
      <input ngbButton type="radio" value="html" > 
      <i class="bi bi-code-slash me-1"></i>HTML
  </label>
  <label ngbButtonLabel class="btn btn-outline-light btn-sm border-0 ms-2">
      <input ngbButton type="radio" value="text" >
      <i class="bi bi-text-paragraph me-1"></i> Text
  </label>
</!--div-->
<!--//////////////////////////////////////////////////////////////////////-->
<!--//////////////////////////////////////////////////////////////////////-->
<!--///////////////PENDING TODO-CHECK FOR ALL PROPERIES///////////////////-->
<!--//////////////////////////////////////////////////////////////////////-->
<!--//////////////////////////////////////////////////////////////////////-->
<fieldset *ngIf="objectContent.hasOwnProperty('value')" class="form-group">
  <label *ngIf="label">{{ label | translate }}<span class="text-muted" *ngIf="showAsterisk">*</span></label>
  <div class="btn-group btn-group-toggle p-1 mb-1">
    <button type="button" class="btn btn-outline-light btn-sm" [class.active]="textFormat === 'html'"
      (click)="textFormat = 'html'">
      HTML
    </button>
    <button type="button" class="btn btn-outline-light btn-sm ms-1" [class.active]="textFormat === 'editor'"
      (click)="textFormat = 'editor'">
      Editor
    </button>
  </div>
  <div [ngClass]="{ 'is-invalid': isInvalid }">
    <!-- HTML source view -->
    <textarea *ngIf="textFormat === 'html'" class="form-control html-view" [class.is-invalid]="isInvalid"
      [(ngModel)]="objectContent.value" (input)="onTextChange($event)" (blur)="onBlur()"></textarea>
    <!-- WYSIWYG editor view -->
    <div *ngIf="textFormat === 'editor'" class="editor-wrapper" [class.is-invalid]="isInvalid">
      <quill-editor [modules]="getQuillConfig()" placeholder="{{ 'editor_placeholder' | translate }}" format="html"
        (onContentChanged)="onTextChange($event)" (onBlur)="onBlur()" [(ngModel)]="objectContent.value"></quill-editor>
    </div>
  </div>
</fieldset>

<!--//////////////////////////////////////////////////////////////////////-->
<!--//////////////////////////////////////////////////////////////////////-->
<!--///////////////PENDING TODO-CHECK FOR ALL PROPERIES///////////////////-->
<!--//////////////////////////////////////////////////////////////////////-->
<!--//////////////////////////////////////////////////////////////////////-->
<fieldset *ngIf="objectContent.hasOwnProperty('description')" class="form-group">
  <label *ngIf="label">{{ label | translate }}<span class="text-muted" *ngIf="showAsterisk">*</span></label>
  <div *ngIf="premiumMode; else descriptionLegacyModes" class="bo-editor-modebar">
    <div class="bo-editor-mode-switch" role="group" [attr.aria-label]="'pd_editor_mode_label' | translate">
      <button type="button" [class.is-active]="textFormat === 'editor'" [attr.aria-pressed]="textFormat === 'editor'"
        (click)="setTextFormat('editor')">
        <i class="bi bi-type" aria-hidden="true"></i>{{ 'pd_editor_visual' | translate }}
      </button>
      <button type="button" [class.is-active]="textFormat === 'html'" [attr.aria-pressed]="textFormat === 'html'"
        (click)="setTextFormat('html')">
        <i class="bi bi-code-slash" aria-hidden="true"></i>{{ 'pd_editor_html' | translate }}
      </button>
    </div>
    <span class="bo-editor-mode-hint">{{ (textFormat === 'editor' ? 'pd_editor_visual_hint' : 'pd_editor_html_hint') | translate }}</span>
  </div>
  <ng-template #descriptionLegacyModes>
    <div class="btn-group btn-group-toggle p-1 mb-1">
      <button type="button" class="btn btn-outline-light btn-sm" [class.active]="textFormat === 'html'"
        (click)="textFormat = 'html'">
        HTML
      </button>
      <button type="button" class="btn btn-outline-light btn-sm ms-1" [class.active]="textFormat === 'editor'"
        (click)="textFormat = 'editor'">
        Editor
      </button>
    </div>
  </ng-template>
  <div class="bo-editor-surface" [ngClass]="{ 'is-invalid': isInvalid }">
    <!-- HTML source view -->
    <textarea *ngIf="textFormat === 'html'" class="form-control html-view" [class.is-invalid]="isInvalid"
      [(ngModel)]="objectContent.description" (input)="onTextChange($event)" (blur)="onBlur()"></textarea>
    <!-- WYSIWYG editor view -->
    <div *ngIf="textFormat === 'editor'" class="editor-wrapper" [class.is-invalid]="isInvalid">
      <quill-editor [modules]="quillConfig1" placeholder="{{ 'editor_placeholder' | translate }}"
        [(ngModel)]="objectContent.description" (onContentChanged)="onTextChange($event)"
        (onBlur)="onBlur()"></quill-editor>
    </div>
  </div>
</fieldset>

<!--//////////////////////////////////////////////////////////////////////-->
<!--//////////////////////////////////////////////////////////////////////-->
<!--///////////////PENDING TODO-CHECK FOR ALL PROPERIES///////////////////-->
<!--//////////////////////////////////////////////////////////////////////-->
<!--//////////////////////////////////////////////////////////////////////-->
<fieldset *ngIf="
    objectContent.hasOwnProperty('endpoint') && htmlContent && htmlContent.hasOwnProperty('html')
  " class="form-group">
  <label *ngIf="label">{{ label | translate }}<span class="text-muted" *ngIf="showAsterisk">*</span></label>
  <div class="d-flex justify-content-between">
    <div class="btn-group btn-group-toggle p-1 mb-1">
      <button type="button" class="btn btn-outline-light btn-sm" [class.active]="textFormat === 'html'"
        (click)="textFormat = 'html'">
        HTML
      </button>
      <button type="button" class="btn btn-outline-light btn-sm ms-1" [class.active]="textFormat === 'editor'"
        (click)="textFormat = 'editor'">
        Editor
      </button>
    </div>
    <div class="align-items-center mb-1">
      <button type="button" class="btn btn-sm btn-outline-primary" (click)="saveHtmlContent()">
        <i class="bi bi-save2-fill me-1"></i>{{ "ac_save" | translate }}
      </button>
    </div>
  </div>
  <div [ngClass]="{ 'is-invalid': isInvalid }">
    <!-- HTML source view -->
    <div *ngIf="textFormat === 'html'" class="position-relative">
      <textarea class="form-control html-view" [class.is-invalid]="isInvalid" [(ngModel)]="htmlContent.html"></textarea>
      <div *ngIf="isLoading"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,0.7); z-index: 1000; display: flex; align-items: center; justify-content: center;">
        <div class="spinner-border text-primary spinner-border-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
    <!-- WYSIWYG editor view -->
    <div *ngIf="textFormat === 'editor'" class="editor-wrapper position-relative" [class.is-invalid]="isInvalid">
      <quill-editor [modules]="quillConfig1" placeholder="{{ 'editor_placeholder' | translate }}" format="html"
        [(ngModel)]="htmlContent.html" (onBlur)="onBlur()"></quill-editor>
      <div *ngIf="isLoading"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255,0.7); z-index: 1000; display: flex; align-items: center; justify-content: center;">
        <div class="spinner-border text-primary spinner-border-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>
  <!--button type="button" class="btn btn-block btn-outline-secondary" (click)="saveHtmlContent()"> Save Html</!--button-->
</fieldset>
